import { Avatar, Box, Typography, Paper } from "@mui/material";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import StarIcon from "@mui/icons-material/Star";

interface Testimonial {
  quote: string;
  name: string;
  specialty?: string;
  registro: string;
  photo?: string;
  // object-position vertical do avatar — só necessário quando a foto é um
  // corpo inteiro/busto estreito e o crop automático pro círculo (que pega o
  // centro) acaba cortando a cabeça. Default (undefined) = "center".
  photoPositionY?: string;
}

// Depoimentos reais, confirmados pelo usuário com nome, texto final, registro
// profissional e foto (public/doctors/). Ver SAL-252.
const testimonials: Testimonial[] = [
  {
    quote:
      "Prescrevo derivados de cannabis desde 2019, e mesmo já tendo uma certa experiência, na hora da consulta com o paciente na minha frente, podem surgir algumas dúvidas. O Dr.Weedy.AI entrou na minha prática clínica para organizar o raciocínio clínico, dirimir dúvidas em tempo real e otimizar a consulta e o acompanhamento dos pacientes. Tudo isso com um arcabouço sólido de referências, baseado em evidências. Veio para dar um upgrade na minha prática e eu não largo mais!",
    name: "Dra. Isolda de Araújo",
    specialty: "Médica Fisiatra",
    registro: "CRM-SP 107017 · RQE 79985",
    photo: "/doctors/isolda.png",
  },
  {
    quote:
      "Comecei a ter resultados que colocaram os Canabinoides acima de qualquer outra medicação que eu conheci em termos de Eficácia, Segurança e Termos de Resposta.",
    name: "Dr. Licínio Alcântara",
    specialty: "Médico Psiquiatra e Psicogeriatra",
    registro: "CRM-SC 8806 · RQE 7125",
    photo: "/doctors/licinio.png",
  },
  {
    quote:
      "O Dr Weedy.IA é o melhor parceiro do prescritor canábico!\n\nTenho utilizado na minha prática clínica e posso dizer que é uma ferramenta realmente diferenciada. Ele não substitui, em nenhum momento, a conduta do prescritor, pelo contrário, atua como um grande aliado no processo de decisão clínica.\n\nO que mais me chama atenção é a forma como ele contribui para um raciocínio mais leve, organizado e assertivo. Muitas vezes, ele valida a linha de pensamento que já estamos seguindo e, em outras, traz novas possibilidades terapêuticas, sugerindo combinações como óleos, gomas e pomadas, ampliando nossa visão sobre o tratamento com canabinoides.\n\nIsso proporciona mais segurança e embasamento na hora de prescrever, sempre respeitando a individualidade de cada paciente.\n\nSou muito grata por ter acesso a uma ferramenta como essa, que tem agregado tanto à minha prática e contribuído diretamente para melhores resultados nos tratamentos de diversas patologias.\n\nSem dúvida, é um recurso que utilizo com frequência e que faz diferença no meu dia a dia clínico. 💚🌱",
    name: "Dra. Íngrid Azevedo",
    specialty: "Cirurgiã-Dentista",
    registro: "CRO-PB 11.599",
    photo: "/doctors/ingrid.png",
  },
  {
    quote:
      "Fiz uma pesquisa agora, de curiosidade mas relacionado a tto distúrbios comportamentais na Doença de Alzheimer!!! A resposta foi uma aula! Resumida, prática!",
    name: "Ronan Junior",
    registro: "CRM-MG 35940 · RQE 23043",
    photo: "/doctors/ronan.png",
  },
  {
    quote:
      "Dr Weedy.IA tem se mostrado uma ferramenta indispensável na minha prática clínica em Medicina Endocanabinoide! Ela traz agilidade e precisão ao estudo de casos complexos, permitindo uma análise mais profunda e fundamentada para cada paciente.\n\nÉ um suporte tecnológico que otimiza o tempo e eleva o rigor científico no cuidado individualizado, sendo uma verdadeira aliada para quem busca excelência nessa área da medicina. Indispensável!!!!",
    name: "Dra. Fabrícia Dourado",
    registro: "CRM-MG 35879",
    photo: "/doctors/fabricia.png",
    photoPositionY: "top",
  },
  {
    quote:
      "Como dentista, sempre busquei ferramentas que realmente agregassem valor ao meu raciocínio clínico. O Dr. Wheedy IA superou todas as minhas expectativas. É uma IA extremamente eficaz para discutir casos complexos, oferecendo análises profundas, sugestões embasadas e, principalmente, estratégias de tratamento altamente individualizadas para cada paciente.\n\nO que mais me impressiona é como ele consegue, de forma rápida e precisa, integrar dados clínicos, evidências científicas e o contexto único de cada caso, ajudando a chegar na melhor conduta possível. Sinto que estou discutindo o caso com um colega extremamente capacitado e atualizado.\n\nDr. Weedy IA não é só uma ferramenta — é um verdadeiro parceiro de raciocínio clínico. Recomendo sem nenhuma reserva.",
    name: "Dra. Edna de Souza Borges",
    specialty: "Cirurgiã-Dentista",
    registro: "CRO-SP 93303",
    photo: "/doctors/edna.png",
  },
  {
    quote:
      "O que mais impressiona na plataforma Weedy.IA não é só a agilidade, mas o embasamento.\n\nSabe aquela insegurança de onde vem a informação? Pois é, o Weedy.IA gera as condutas baseadas estritamente na literatura científica e ainda cita cada uma das referências. Além de indicar o caminho, ele disponibiliza os artigos científicos completos para consulta direta na plataforma.\n\nÉ o combo perfeito: você ganha tempo no consultório, mas com a tranquilidade de ter toda a evidência científica ali, a um clique. Para quem preza por uma medicina baseada em evidências, é uma ferramenta indispensável!",
    name: "Dra. Monica Noronha",
    specialty: "Cirurgiã-Dentista",
    registro: "CRO 64.392",
    photo: "/doctors/monica.png",
  },
  {
    quote:
      "Quero agradecer ao fundador do Dr Weedy IA por desenvolver este programa. Ele tem sido fundamental na minha jornada, trazendo mais segurança, clareza e apoio no uso da cannabis medicinal com meus pacientes.",
    name: "Dra. Nay Jussara Soares de Souza",
    registro: "CRM 37782",
    photo: "/doctors/nay.png",
    photoPositionY: "10%",
  },
  {
    quote: "Weedy é fantástica! Amei a disposição dela em ajudar! 👏💚",
    name: "Dra. Patrícia Hazin",
    registro: "CRM-MG 36.309",
    photo: "/doctors/patricia.png",
  },
  {
    quote:
      "O que falar da Weedy IA? Auxílio? Socorro? Hoje, a Weedy IA é, na minha prática clínica, uma grande aliada, quase como uma professora e uma consultora de confiança. É nela que encontro apoio para esclarecer dúvidas sobre canabinologia, entender interações com outras medicações, avaliar riscos e benefícios e conduzir cada paciente com mais segurança, responsabilidade e cuidado.",
    name: "Dr. Eder Moraes",
    registro: "CRM-MS 7470",
    photo: "/doctors/eder.png",
  },
];

export default function TestimonialsSection() {
  return (
    <section className="relative z-10 px-6 md:px-12 pb-20 md:pb-28">
      <div className="text-center mb-14">
        <Typography
          sx={{
            color: "#FF8904",
            fontWeight: 700,
            fontSize: "0.8rem",
            letterSpacing: "0.15em",
            marginBottom: "12px",
          }}
        >
          DEPOIMENTOS
        </Typography>
        <Typography
          variant="h4"
          sx={{
            color: "#ffffff",
            fontWeight: 700,
            fontFamily: "Oxanium, sans-serif",
            letterSpacing: "-0.02em",
            fontSize: { xs: "1.5rem", md: "2rem" },
          }}
        >
          O que dizem os médicos
        </Typography>
      </div>

      <Box
        sx={{
          columnCount: { xs: 1, md: 2, lg: 3 },
          columnGap: "24px",
          maxWidth: "1152px",
          margin: "0 auto",
        }}
      >
        {testimonials.map((testimonial) => (
          <Paper
            key={testimonial.name}
            elevation={0}
            sx={{
              breakInside: "avoid",
              marginBottom: "24px",
              background:
                "linear-gradient(135deg, rgba(26, 49, 60, 0.6) 0%, rgba(4, 9, 10, 0.8) 100%)",
              backdropFilter: "blur(16px)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: "24px",
              padding: "32px",
            }}
          >
            <div className="flex gap-0.5 mb-4">
              {Array.from({ length: 5 }).map((_, i) => (
                <StarIcon key={i} sx={{ color: "#FF8904", fontSize: 18 }} />
              ))}
            </div>

            <Typography
              sx={{
                color: "rgba(255,255,255,0.7)",
                fontStyle: "italic",
                fontSize: "0.95rem",
                lineHeight: 1.6,
                marginBottom: "20px",
                whiteSpace: "pre-line",
              }}
            >
              "{testimonial.quote}"
            </Typography>

            <div className="flex items-center gap-3 pt-4 border-t border-white/10">
              <Avatar
                src={testimonial.photo}
                alt={testimonial.name}
                sx={{
                  width: 48,
                  height: 48,
                  backgroundColor: "rgba(255,255,255,0.1)",
                  "& .MuiAvatar-img": {
                    objectPosition: `center ${testimonial.photoPositionY ?? "center"}`,
                  },
                }}
              >
                <PersonOutlineOutlinedIcon sx={{ color: "rgba(255,255,255,0.5)" }} />
              </Avatar>
              <div>
                <Typography sx={{ color: "#ffffff", fontWeight: 700, fontSize: "1rem" }}>
                  {testimonial.name}
                </Typography>
                <Typography sx={{ color: "rgba(255,255,255,0.5)", fontSize: "0.85rem" }}>
                  {testimonial.specialty ? `${testimonial.specialty} · ` : ""}
                  {testimonial.registro}
                </Typography>
              </div>
            </div>
          </Paper>
        ))}
      </Box>
    </section>
  );
}
